import { foldazApi } from 'api'
import { i18n } from '@/i18n'

import {
  CONTENT_EXPORT_REQUEST,
  CONTENT_EXPORT_SUCCESS,
  CONTENT_EXPORT_ERROR,
  SET_FORMAT,
  SET_STEP_INDEX,
  SET_ARTICLES,
  SELECT_ARTICLE,
  SELECT_ALL_ARTICLES
} from './types'

export const state = {
  articles: [],
  articlesSelected: [],
  stepIndex: 0,
  steps: [
    'StepFormat',
    'StepArticles',
    'StepOutput'
  ],
  form: {
    format: 'html'
  },
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [CONTENT_EXPORT_REQUEST] (state) {
    state.request.isLoading = true
  },

  [CONTENT_EXPORT_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },

  [CONTENT_EXPORT_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },

  [SET_FORMAT] (state, value) {
    state.form.format = value
  },

  [SET_STEP_INDEX] (state, value) {
    state.stepIndex = value
  },

  [SET_ARTICLES] (state, value) {
    state.articles = value

    // update selected
    state.articlesSelected = state.articles.map(article => article.id).filter(id => state.articlesSelected.indexOf(id) !== -1)
  },

  [SELECT_ARTICLE] (state, { id }) {
    const index = state.articlesSelected.indexOf(id)

    if (index == -1) {
      state.articlesSelected.push(id)
    } else {
      state.articlesSelected.splice(index, 1)
    }

    state.articlesSelected = state.articles.map(article => article.id).filter(id => state.articlesSelected.indexOf(id) !== -1)
  },

  [SELECT_ALL_ARTICLES] (state, value) {
    state.articlesSelected = value ? state.articles.map(article => article.id) : []
  }
}

export const actions = {
  setFormat ({ commit }, payload) {
    commit(SET_FORMAT, payload)
  },

  fetchArticles ({ commit }, params) {
    return foldazApi.get('/contents', params)
      .then(response => response.data)
      .then(data => {
        commit(SET_ARTICLES, data.entries)
      })
  },

  useSearchContent ({ commit, rootState }) {
    const contents = rootState.contents.contents.filter((content) => content.shareable === true)

    commit(SET_ARTICLES, contents)
  },

  setArticles ({ commit }, value) {
    commit(SET_ARTICLES, value)
  },

  selectArticle ({ commit }, payload) {
    commit(SELECT_ARTICLE, payload)
  },

  selectAllArticles ({ commit }, payload) {
    commit(SELECT_ALL_ARTICLES, payload)
  },

  nextStep ({ commit, state }) {
    commit(SET_STEP_INDEX, state.stepIndex + 1)
  },

  export ({ commit }, { title, format, contentIds }) {
    commit(CONTENT_EXPORT_REQUEST)

    return foldazApi.post('/exports', {
        export: {
          content_ids: contentIds.join(','),
          format: format,
          title: title
        }
      })
        .then(response => {
          commit(CONTENT_EXPORT_SUCCESS)
          return response.data
        })
        .catch(error => {
          commit(CONTENT_EXPORT_ERROR, error)
        })
  },

  exportFolder ({ commit }, { folderId, title, format }) {
    commit(CONTENT_EXPORT_REQUEST)

    const params = {
      params: {
        folder_ids: [folderId]
      }
    }

    return foldazApi.get('/contents', params)
      .then(response => response.data)
      .then(data => data.entries.map(entry => entry.id))
      .then(contentIds => foldazApi.post('/exports', {
        export: {
          content_ids: contentIds.join(','),
          format: format,
          title: title
        }
      }))
        .then(response => {
          commit(CONTENT_EXPORT_SUCCESS)
          return response.data
        })
        .catch(error => {
          commit(CONTENT_EXPORT_ERROR, error)
        })
  },

  reset ({ commit }) {
    commit(SET_FORMAT, 'html')
    commit(SET_STEP_INDEX, 0)
    commit(SET_ARTICLES, [])
  }
}

export const getters = {
  currentStep (state) {
    return state.steps[state.stepIndex]
  },

  formatOptions () {
    return [
      { label: i18n.t('c.contentExportOverlay.stepFormat.form.options.html'), value: 'html' },
      { label: i18n.t('c.contentExportOverlay.stepFormat.form.options.pdf'), value: 'pdf' }
    ]
  },

  isArticleSelected (state) {
    return ({ id }) => {
      return state.articlesSelected.indexOf(id) !== -1
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contentExport.js